var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VR__container"},[_c('header-wrap'),_vm._v(" "),_c('div',{staticClass:"vr-box"},[(_vm.vrSrc)?_c('iframe',{attrs:{"src":_vm.vrSrc,"frameborder":"no","width":"100%","height":"100%"}}):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663d09df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VR/index.vue
// module id = null
// module chunks = 